import { render, staticRenderFns } from "./newWindow.vue?vue&type=template&id=aa25e7c6&"
import script from "./newWindow.vue?vue&type=script&lang=js&"
export * from "./newWindow.vue?vue&type=script&lang=js&"
import style0 from "./newWindow.vue?vue&type=style&index=0&id=aa25e7c6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports